/**
 * Area `visitor-signing-secret` of the console gateway — over `apps/api/src/routes/visitor-signing-secret/`. Owned by
 * plan-029 unit **WAPP-VIS**: the widget binding's visitor signing secrets — create (shown once), rotate, retire, the
 * console signature (design §40.19.9, DD29-3, DD29-16; ADR 0083, proposed).
 *
 * EMPTY ON PURPOSE. plan-029 REG created this slice and spread it once into `../api-gateway.ts` (and its sandbox,
 * `../sandbox/visitor-signing-secret.ts`, into `../sandbox-gateway.ts`; its gap rows into `../gateway.ts`'s
 * `GATEWAY_GAP`), so no plan-029 unit edits those three files (plan-029 §2.2, ED-21). WAPP-VIS merges its methods onto
 * `ConsoleGateway` here with `declare module "../gateway.js"`, widens `VisitorSigningSecretGatewaySlice` to
 * `Pick<ConsoleGateway, …its methods>`, implements them below over the generated client, and lists in
 * `visitorSigningSecretGap` any method whose operation the assembled spec does not carry yet (owner `plan-029 <unit>`).
 */
import type { WeTalkApiClient } from "@wetalk/api-client";

import type { ConsoleGateway } from "../gateway.js";
import type { GatewayGap, SliceContext } from "./slice-context.js";

/** The methods this slice puts on `ConsoleGateway`. None yet. */
export type VisitorSigningSecretGatewaySlice = Pick<ConsoleGateway, never>;

/** This area's rows of `GATEWAY_GAP`. */
export const visitorSigningSecretGap: readonly GatewayGap[] = [];

export function visitorSigningSecretApiSlice(_client: WeTalkApiClient, _context: SliceContext): VisitorSigningSecretGatewaySlice {
  return {};
}
